import { ModelSagres } from "../../model-sagres";

import { ArquivoAditivo } from "../arquivo-aditivo";
import { Contrato } from "../contratos/contrato";
import { NaturezaAjuste } from "../natureza-ajuste";
import { TipoTermoAditivo } from "../tipo-termo-aditivo";

import { UtilsTS } from "@/utilsts";

export class AditivoContrato extends ModelSagres {
  IdAditivoContrato: number;
  IdContrato: number;
  IdNaturezaAjuste: number;
  IdUnidGestora: number;
  NrAditivoContrato: number;
  NrAnoAditivoContrato: number;
  DeJustificativaAditivo: string;
  DtInicioVigenciaAditivo: Date | null;
  DtFimVigenciaAditivo: Date | null;
  VlAditivoContrato: number | null;
  DtAssinaturaAditivo: Date;
  DtAnulacaoAditivo: Date | null;
  DeMotivoAnulacaoAditivo: string | null;
  DtPublicacaoAditivo: Date;
  NmUsuarioUltimaAlteracao: string;
  DtUltimaAlteracao: Date;
  IdTipoTermoAditivo: number;
  CdCpfCnpjParticipante: string | null;
  NmParticipante: string | null;
  DeJustificativaAlteracaoSubjetiva: string | null;
  IdContratoNavigation: Contrato;
  IdNaturezaAjusteNavigation: NaturezaAjuste;
  IdTipoTermoAditivoNavigation: TipoTermoAditivo;
  ArquivoAditivoContrato: ArquivoAditivo[];

  DescricaoContrato: string;

  tratarDadosDaAPI(): void {
    if (this.DtInicioVigenciaAditivo) {
      this.DtInicioVigenciaAditivo = new Date(this.DtInicioVigenciaAditivo);
    }
    if (this.DtFimVigenciaAditivo) {
      this.DtFimVigenciaAditivo = new Date(this.DtFimVigenciaAditivo);
    }
    if (this.DtAssinaturaAditivo) {
      this.DtAssinaturaAditivo = new Date(this.DtAssinaturaAditivo);
    }

    if (this.DtAnulacaoAditivo) {
      this.DtAnulacaoAditivo = new Date(this.DtAnulacaoAditivo);
    }
    if (this.DtPublicacaoAditivo) {
      this.DtPublicacaoAditivo = new Date(this.DtPublicacaoAditivo);
    }
    if (this.DtUltimaAlteracao) {
      this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao);
    }
    if (this.IdContratoNavigation)
      this.DescricaoContrato = `${this.IdContratoNavigation.NrContrato}/${this.IdContratoNavigation.NrAnoContrato} - ${this.IdContratoNavigation.DeObjetoContrato}`;
  }
}
